
import { Options, Vue, setup } from 'vue-class-component'
import { LimitPageVariants, LimitPageDefault } from '@/composables/constants'
import { list, SortingDefault } from '@/composables/history/list'
import { Sorting } from '@/services/types'
import { positiveInt } from '@/composables/mask'

import BaseModal from '@/components/ui/BaseModal.vue'
import AddBalanceForm from '@/components/forms/AddBalanceForm.vue'
import EditBalanceForm from '@/components/forms/EditBalanceForm.vue'
import { HistoryModels } from '@/composables/history/history-models'

@Options({
  components: { BaseModal, AddBalanceForm, EditBalanceForm  },
  props: {
    mlmId: Number,
    agentId: Number,
  },
})

export default class Balance extends Vue {
  formRef: { submit: () => void } | null = null
  earningPendingStatuses = [1, 2]
  loadingStates: { [key: number]: boolean } = {}
  showOptions = false
  page = 1
  limit = LimitPageDefault.value
  sorting: Sorting = SortingDefault
  agentId!: number

  isAddModalOpen = false
  isEditModalOpen = false
  selectedRecord: HistoryModels | null = null

  ctx = setup(() => {
    return {
      ...list(),
      LimitPageVariants,
    }
  })

  created(): void {
    this.clear()
  }

  // ===========================
  // Модальное окно добавления
  // ===========================

  openAddModal() {
    this.isAddModalOpen = true
  }

  closeAddModal() {
    this.isAddModalOpen = false
  }

  openEditModal(history: HistoryModels) {
    this.selectedRecord = history
    this.isEditModalOpen = true
  }

  closeEditModal() {
    this.selectedRecord = null
    this.isEditModalOpen = false
  }

  submitForm() {
    console.log(this.formRef)
    this.formRef?.submit?.()
  }

  async onAddBalance(): Promise<void> {
    this.closeAddModal()
    await this.fetch()
  }

  async onEditBalance(): Promise<void> {
    this.closeEditModal()
    await this.fetch()
  }

  // ===========================
  // Таблица
  // ===========================

  async changePage(): Promise<void> {
    this.page = positiveInt(this.page)
    await this.fetch()
  }

  async apply() {
    this.page = 1
    await this.fetch()
  }

  async clear() {
    this.ctx.reset()
    this.ctx.setFilterAgentId(this.agentId)
    this.cancel()
    await this.fetch()
  }

  cancel() {
    this.page = this.ctx.meta.offset / this.ctx.meta.limit + 1
    this.limit = this.ctx.meta.limit
    this.sorting = this.ctx.sorting
    this.close()
  }

  close() {
    this.showOptions = false
  }

  scroll() {
    document.getElementById('table')?.scrollTo({ top: 0, behavior: 'smooth' })
  }

  async declineEarning(earningId: number) {
    this.loadingStates[earningId] = true
    try {
      await this.ctx.updateHoldStatus(earningId, 4)
    } catch (error) {
      console.error('Ошибка при отклонении:', error)
    } finally {
      this.loadingStates[earningId] = false
    }
  }

  async acceptEarning(earningId: number) {
    this.loadingStates[earningId] = true
    try {
      await this.ctx.updateHoldStatus(earningId, 0)
    } catch (error) {
      console.error('Ошибка при принятии:', error)
    } finally {
      this.loadingStates[earningId] = false
    }
  }

  async fetch() {
    this.ctx.setLimit(this.limit)
    this.ctx.setPage(this.page)
    this.ctx.setSorting(this.sorting)

    await this.ctx.fetch()
    this.close()
    this.scroll()
  }
}
